export default __webpack_public_path__ + "static/media/organization.e4ce71c6.svg";